import React from 'react';
import { Button } from '../../../components/button/button';
import { FormattedMessage } from 'react-intl';
import Popover from '../../../components/popover/popover';
import { AuthorizedMenu } from './authorized-menu';
import avatar from '../../../assets/images/user/user-1.svg';

// interface Props {
//   isAuthenticated: boolean;
//   onJoin: () => void;
//   onLogout: () => void;
//   avatar: string;
// }

const AuthMenu = ({ isAuthenticated, onJoin, onLogout }) => {
  return !isAuthenticated ? (
    <Button variant="primary" onClick={onJoin}>
      <FormattedMessage id="joinButton" defaultMessage="join" />
    </Button>
  ) : (
    <Popover
      direction="right"
      className="user-pages-dropdown"
      handler={<img src={avatar} alt="user" />}
      content={<AuthorizedMenu onLogout={onLogout} />}
    />
  );
};
export default AuthMenu;
